import TESubmit from './TESubmit';

export default TESubmit;
